import React, { useEffect, useState } from "react";
import logo from "../../img/logo1.png";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { LogoName } from "../../constants";
import useMediaQuery from "../../utils/media-query";
import "../../css/style.css";

const Header: React.FC = () => {
  const [activeMenuItem, setActiveMenuItem] = useState<string>("Home");
  const [mobileNavActive, setMobileNavActive] = useState<boolean>(false);

  const handleMenuItemClick = (itemName: string) => {
    setActiveMenuItem(itemName);
    setMobileNavActive(false);
  };

  const isMobile = useMediaQuery("(max-width: 767px)");
  const styles = { display: isMobile ? "grid" : "flex" };

  useEffect(() => {
    const setupMobileNavigation = () => {
      const $navMenuContainer = $("#nav-menu-container");

      if ($navMenuContainer.length) {
        const $mobileNav = $navMenuContainer.clone().prop({
          id: "mobile-nav",
        });
        $mobileNav.find("> ul").attr({
          className: "",
          id: "",
        });

        $("body").append($mobileNav);
        $("body").prepend(
          '<button type="button" id="mobile-nav-toggle"><i class="fa fa-bars"></i></button>'
        );
        $("body").append('<div id="mobile-body-overlay"></div>');

        $("#mobile-nav")
          .find(".menu-has-children")
          .prepend('<i class="fa fa-chevron-down"></i>');

        // Handle click event for mobile navigation toggle button
        $(document).on("click", "#mobile-nav-toggle", function (e) {
          $("body").toggleClass("mobile-nav-active");
          $("#mobile-nav-toggle i").toggleClass("fa-times fa-bars");
          $("#mobile-body-overlay").toggle();
          setMobileNavActive((prev) => !prev); // Toggle mobileNavActive state
        });

        // Handle click event to close mobile navigation when clicking outside the menu
        $(document).on("click", function (e) {
          const container = $("#mobile-nav, #mobile-nav-toggle");
          const isContainerClicked =
            container.is(e.target as unknown as any) ||
            container.has(e.target as unknown as any).length > 0;

          if (!isContainerClicked && $("body").hasClass("mobile-nav-active")) {
            $("body").removeClass("mobile-nav-active");
            $("#mobile-nav-toggle i").toggleClass("fa-times fa-bars");
            $("#mobile-body-overlay").fadeOut();
            setMobileNavActive(false); // Set mobileNavActive state to false
          }
        });
      } else if ($("#mobile-nav, #mobile-nav-toggle").length) {
        $("#mobile-nav, #mobile-nav-toggle").hide();
      }

      $("#mobile-nav a").on("click", function () {
        // Optionally, remove the mobile-nav-active class from the body
        $("body").removeClass("mobile-nav-active");
      });
    };

    setupMobileNavigation();

    // Clean up event listeners on component unmount
    return () => {
      $(document).off("click", ".menu-has-children i");
      $(document).off("click", "#mobile-nav-toggle");
      $(document).off("click");
    };
  }, [mobileNavActive]);
  return (
    <header id="header">
      <div className="container-fluid">
        <div id="logo" className="pull-left" style={{ display: "flex" }}>
          <a href="#intro">
            <img src={logo} alt="" title="" />
          </a>
          <h1 style={{ marginLeft: "10px" }}>
            <a href="#intro" className="scrollto">
              {LogoName}
            </a>
          </h1>
        </div>

        <nav id={"nav-menu-container"}>
          <button
            type="button"
            id="mobile-nav-toggle"
            style={{ color: "#00008B" }}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <ul className="nav-menu" style={styles}>
            <li className={activeMenuItem === "Home" ? "menu-active" : ""}>
              <a href="#intro" onClick={() => handleMenuItemClick("Home")}>
                Home
              </a>
            </li>
            <li className={activeMenuItem === "About Us" ? "menu-active" : ""}>
              <a href="#about" onClick={() => handleMenuItemClick("About Us")}>
                About Us
              </a>
            </li>
            <li className={activeMenuItem === "Services" ? "menu-active" : ""}>
              <a
                href="#services"
                onClick={() => handleMenuItemClick("Services")}
              >
                Services
              </a>
            </li>
            <li className={activeMenuItem === "Album" ? "menu-active" : ""}>
              <a href="#portfolio" onClick={() => handleMenuItemClick("Album")}>
                Album
              </a>
            </li>
            <li className={activeMenuItem === "Contact" ? "menu-active" : ""}>
              <a href="#contact" onClick={() => handleMenuItemClick("Contact")}>
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
